/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Input from 'components/inputs/Input/Input';
import Button2 from 'components/buttons/Button2/Button2';
import Message2 from 'components/messages/Message2';
import { ReactComponent as PaperPlane } from 'assets/icons/paper-plane.svg';
import withTitle from 'hocs/WithTitle';
import { useRecoverPassword } from './useRecoverPassword';
import styles from './style.cssmodule.css';

const Recover = ({
  handleFormTypeChange,
}) => {
  const { formatMessage: t } = useIntl();

  const {
    fields,
    changeField,
    submitStatus,

    errors,
    isSubmitting,

    handleSubmit,
  } = useRecoverPassword({
    handleFormTypeChange,
  });

  let Message = null;
  if (submitStatus === 'success') {
    Message = (
      <Message2
        type="success"
        className={styles.messageTopRight}
        title={t({ id: 'message.title.sendInstructions' })}
      >
        {t({ id: 'message.description.sendInstructions' })}
      </Message2>
    );
  }

  return (
    <form>
      {Message}
      <div className={styles.inputGrid}>
        <Input
          label={t({ id: 'field.emailExplicitConnexionLinkedAccount' })}
          type="email"
          name="email"
          autoComplete="email"
          disabled={isSubmitting}
          value={fields.email}
          error={errors.email}
          onChange={({ target: { value: newEmail } }) => changeField({ name: 'email', value: newEmail })}
        />
      </div>
      <Button2
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
        type="primary"
        className={styles.recoverPasswordButton}
        size="medium"
      >
        {t({ id: 'button.sendInstructions' })}
        <PaperPlane />
      </Button2>
    </form>
  );
};

Recover.propTypes = {
  handleFormTypeChange: PropTypes.func,
};

Recover.defaultProps = {
  handleFormTypeChange: () => {},
};

module.exports = withTitle('pageTitle.recoverPassword')(Recover);



// WEBPACK FOOTER //
// ./routes/login/components/cpm_client/components/Recover/Recover.jsx